import React, { PureComponent, Fragment } from 'react'
import {
  DialogContent,
  DialogActions,
  Button,
  Divider
} from '@material-ui/core'
import { Print as PrintIcon } from '@material-ui/icons'

import { BookingsSumSheet, PrintWindow } from 'components'

export class PrintBookingsRangeSheetBase extends PureComponent {
  state = {
    isPrintWindow: false
  }

  openPrintWindow = () => this.setState({ isPrintWindow: true })

  renderPrintWindow = bookings => (
    <PrintWindow>
      <BookingsSumSheet bookings={bookings} convert={this.props.convert} />
    </PrintWindow>
  )

  render() {
    const { data: { bookings, convert }, onClose } = this.props
    const { isPrintWindow } = this.state

    return (
      <Fragment>

        {isPrintWindow && this.renderPrintWindow(bookings)}

        <DialogActions>
          <Button color='secondary' onClick={onClose}>
            Скасувати
          </Button>
          <Button color='primary' onClick={this.openPrintWindow}>
            Роздрукувати
            <PrintIcon fontSize='small' style={{ marginLeft: 5 }} />
          </Button>
        </DialogActions>

        <Divider />

        <DialogContent>
          <BookingsSumSheet bookings={bookings} convert={convert} />
        </DialogContent>
        
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PrintBookingsRangeSheet/PrintBookingsRangeSheet.js